import { inherits as _inherits, createClass as _createClass, defineProperty as _defineProperty, classCallCheck as _classCallCheck, callSuper as _callSuper } from '../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/Modal';
import { Button } from './Button/index.js';

var SelectionModal = /*#__PURE__*/function (_React$Component) {
  function SelectionModal() {
    _classCallCheck(this, SelectionModal);

    return _callSuper(this, SelectionModal, arguments);
  }

  _inherits(SelectionModal, _React$Component);

  return _createClass(SelectionModal, [{
    key: "renderFooter",
    value: function renderFooter() {
      var _this = this;

      var footerCloseButton = this.props.footerCloseButton;

      if (footerCloseButton) {
        var isTurnedOn = footerCloseButton.isTurnedOn,
            text = footerCloseButton.text;

        if (isTurnedOn) {
          return /*#__PURE__*/React.createElement(Modal.Footer, null, /*#__PURE__*/React.createElement(Button, {
            style: "primary",
            disabled: !this.props.selectionMade,
            onClick: function onClick() {
              return _this.props.onClose(false);
            },
            label: text || 'Cancel'
          }));
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          container = _this$props.container,
          onClose = _this$props.onClose,
          id = _this$props.id,
          canClose = _this$props.canClose,
          show = _this$props.show,
          title = _this$props.title;
      return /*#__PURE__*/React.createElement(Modal, {
        animation: false,
        backdrop: canClose ? true : 'static',
        container: container,
        className: "selectionModal",
        id: id,
        keyboard: canClose,
        onHide: function onHide() {
          return onClose(true);
        },
        show: show
      }, /*#__PURE__*/React.createElement(Modal.Header, {
        closeButton: true
      }, /*#__PURE__*/React.createElement(Modal.Title, null, title)), /*#__PURE__*/React.createElement(Modal.Body, null, this.props.children), this.renderFooter());
    }
  }]);
}(React.Component);

_defineProperty(SelectionModal, "propTypes", {
  children: PropTypes.any,
  canClose: PropTypes.bool,
  container: PropTypes.node,
  onClose: PropTypes.func,
  title: PropTypes.string,
  id: PropTypes.string,
  show: PropTypes.bool,
  selectionMade: PropTypes.string,
  footerCloseButton: PropTypes.shape({
    isTurnedOn: PropTypes.bool,
    text: PropTypes.string
  })
});

_defineProperty(SelectionModal, "defaultProps", {
  show: true,
  closeButton: true
});

SelectionModal.displayName = "SelectionModal";
export { SelectionModal };